import { StorageService } from '../StorageService';
import { LocalStorageOptionsModel } from '@Engage.Data/models/LocalStorageOptionsModel';
import { LocalStorage } from '@Engage.Core';
import { StorageKeys } from '../../../constants/Constants';
import { CookiesStorageService } from '../cookies/CookiesStorageService';
class LocalStorageService extends StorageService {
    //#region Ctor
    constructor() {
        super();
        this.localStorage = new LocalStorage();
    }
    //#endregion
    //#region public
    isSupported() {
        return this.localStorage.isSupported();
    }
    getStorage() {
        return this.localStorage;
    }
    get(key, options) {
        options = this.getOptions(options);
        // DebugSecurityService.addToDebug(DebugTypes.LocalStorage, key, "get", null, options, this);
        let expandedKey = key;
        if (options.expandKey) {
            expandedKey = this.expandKey(key);
        }
        return this.getStorage().get(expandedKey, options.isJson);
    }
    set(key, data, options) {
        let success = false;
        try {
            options = this.getOptions(options);
            // DebugSecurityService.addToDebug(DebugTypes.LocalStorage, key, "set", null, options, this);
            let expandedKey = key;
            if (options.expandKey) {
                expandedKey = this.expandKey(key);
            }
            success = this.getStorage().set(expandedKey, data, options.isJson);
        }
        catch (ex) {
            success = false;
            //logService.error("LocalStorageService", "setKey", ex);
        }
        finally {
            return success;
        }
    }
    getIfNotExpired(key) {
        let result = JSON.parse(this.get(key));
        if (result) {
            if (result.expiry <= Date.now()) {
                this.delete(key);
                return null;
            }
            return result.data;
        }
        return null;
    }
    setWithExpiry(key, data, maxAgeInDays = 1) {
        let result = {
            data: data,
            expiry: Date.now() + (maxAgeInDays * 24 * 60 * 60 * 1000)
        };
        return this.set(key, JSON.stringify(result));
    }
    delete(key, options) {
        options = this.getOptions(options);
        let expandedKey = key;
        if (options.expandKey) {
            expandedKey = this.expandKey(key);
        }
        return this.getStorage().delete(expandedKey);
    }
    clear() {
        return this.getStorage().clear();
    }
    getAllKeys() {
        return this.getStorage().getAllKeys();
    }
    // public getAllConnextRecords(): StorageRecordModel[]{
    //     let records: StorageRecordModel[] = [];
    //     let existingStorageKeys = this.getConnextExistingStorageKeys();
    //     each(existingStorageKeys, (storageKey) => {
    //         let value = this.get(storageKey, { expandKey: false, isJson: true });
    //         if (value === undefined || value === null) {
    //             value = this.get(storageKey, { expandKey: false, isJson: false });
    //         }
    //         records.push({
    //             Name: storageKey,
    //             Value: value
    //         });
    //     });
    //     return records;
    // }
    getConnextExistingStorageKeys(isCheckAllKeys = true) {
        let existingStorageKeys = this.getAllKeys();
        let constantStorageKeys = isCheckAllKeys ? this.getAllConstantKeys() : this.getStorageConstantKeys();
        constantStorageKeys = this.removeExceptionsFromKeys(constantStorageKeys);
        existingStorageKeys = this.filterConnextExistingStorageKeys(existingStorageKeys, constantStorageKeys);
        return existingStorageKeys;
    }
    getStorageConstantKeys() {
        return this.getConstantKeys(StorageKeys);
    }
    getAllConstantKeys() {
        return this.getStorageConstantKeys().concat(CookiesStorageService.getStorageConstantKeys());
    }
    //#endregion
    //#region private
    getOptions(options) {
        return Object.assign(new LocalStorageOptionsModel(), options);
    }
}
export const localStorageService = new LocalStorageService();
